import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { globalStyle, style } from '@vanilla-extract/css';
import { sidebarWrapperCollapsed } from '../sidebar.css';

export const menu = style({
  display: 'grid',
  paddingBottom: 'env(safe-area-inset-bottom)',
  transition: 'padding 0.2s ease-in-out',

  ...responsiveStyle({
    mobile: {
      textAlign: 'center',
      gridAutoFlow: 'column',
      gridAutoColumns: '1fr',
    },
    tablet: {
      gridTemplateColumns: 'repeat(1, 1fr)',
      gridAutoFlow: 'row',
    },
    laptop: {
      padding: `0px ${space.s24}px`,
    },
  }),
});

globalStyle(`.${sidebarWrapperCollapsed} .${menu}`, {
  padding: 0,
});

export const moreMenuDropdown = style({
  selectors: {
    '&:is(&)': {
      padding: 0,
      backgroundColor: themeVars.nav.base,
      borderColor: themeVars.nav.border,
    },
  },
});

export const toolsMenuItem = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s14,
});

export const adminAction = style({
  selectors: {
    '&:is(&)': {
      color: themeVars.container.foreground.warning,
    },
  },
});
